(function() {
  'use strict';

  angular
    .module('admin.publishers.royalties.service', [])
    .factory('RoyaltiesAdminService', RoyaltiesAdminService);

  /** @ngInject */
  function RoyaltiesAdminService($http, $q, API) {

    function list(parentId, start, limit){
        var defer = $q.defer();

        $http.get(API.API_URL + 'admin/publishers/'+ parentId + '/royalties?start=' + start + '&limit=' + limit)
            .success(defer.resolve);

        return defer.promise;
    }

    function get(id){
        var defer = $q.defer();

        $http.get(API.API_URL + 'admin/royalties/' + id)
            .success(defer.resolve);

        return defer.promise;
    }

    function save(parentId, model){
        var defer = $q.defer();

        $http.post(API.API_URL + 'admin/publishers/'+ parentId + '/royalties', model)
          .success(defer.resolve)
          .error(defer.reject);

        return defer.promise;
    }

    function update(id, model){
        var defer = $q.defer();

        $http.post(API.API_URL + 'admin/royalties/' + id, model)
          .success(defer.resolve)
          .error(defer.reject);

        return defer.promise;
    }

    function remove(id){
        var defer = $q.defer();

        $http.delete(API.API_URL + 'admin/royalties/' + id)
          .success(defer.resolve)
          .error(defer.reject);

        return defer.promise;
    }

    return{
        list: list,
        get: get,
        save: save,
        update: update,
        remove: remove,
    };

  }

})();
